import LocalizationStore from '../Stores/LocalizationStore'
import { AjvError, FormValidation } from 'react-jsonschema-form'

const ls = LocalizationStore.getInstance()

export class ChangePasswordFormData {
    id: string
    password: string
    newPassword: string
    confirmPassword: string

    // constructor() {}
}

export function getUserChangePasswordFormSchema(): any {
    return {
        'title': ls.t!('Change password'),
        'type': 'object',
        'required': [
            'oldPassword',
            'password',
            'confirmPassword'
        ],
        'properties': {
            'oldPassword': {
                'title': ls.t!('currentPassword'),
                'type': 'string'
            },
            'password': {
                'title': ls.t!('newPassword'),
                'type': 'string'
            },
            'confirmPassword': {
                'title': ls.t!('confirmPassword'),
                'type': 'string'
            }
        }
    }
}

export const uiUserChangePasswordFormSchema = {
    'password': {
        'ui:widget': 'password'
    },
    'oldPassword': {
        'ui:widget': 'password'
    },
    'confirmPassword': {
        'ui:widget': 'password'
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        // if (error['name'] === 'required') {
        //     error['message'] = ls.t('is a required property')
        // }
        return error
    })
}

export function validate(formData: ChangePasswordFormData, errors: FormValidation) {
    // if (!formData.user.email) {
    //     errors.user['email'].addError(ls.t('Invalid email'))
    // }
    return errors
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/UserChangePasswordForm.tsx